import * as z from 'zod';

export type ToolSchemaShape = Record<string, z.ZodType>;
